import React from 'react';

const AdSliderOne = () => {
    return (
        <div className={'ad-slider-item ad-slider-one'}>
            <h2 className={'ad-slider-one__title'}>PERN SHOP</h2>
            <span className={'ad-slider-one__subtitle'}>торговая площадка</span>
            <span className={'ad-slider-one__info'}>Тысячи магазинов уже ждут вас</span>
        </div>
    );
};

export default AdSliderOne;